import type {
  JourneyCampaignSyncPreviewCountry,
  SheetSyncCampaignRef,
  SheetSyncPreviewResponse,
} from 'omega-rtc/types/ts/journey-sheet-sync';

type Country = { countryID: number | string; code: string; name: string };

// Only a token for exactly the currently reviewed campaigns may be applied.
export const isSheetSyncPreviewForCampaigns = (
  preview: SheetSyncPreviewResponse | undefined,
  campaigns: SheetSyncCampaignRef[],
): boolean => {
  if (!preview || !preview.previewToken || !campaigns.length || !preview.campaigns
    || preview.campaigns.length !== campaigns.length) return false;
  return campaigns.every((campaign) => preview.campaigns.some((result) => (
    result.campaignID === campaign.campaignID
    && result.projectID === campaign.projectID
    && String(result.countryID) === String(campaign.countryID)
  )));
};

export const buildJourneyCampaignSyncPreview = (
  preview: SheetSyncPreviewResponse | undefined,
  campaigns: SheetSyncCampaignRef[],
  countries: Country[] = [],
): JourneyCampaignSyncPreviewCountry[] => ((preview && preview.campaigns) || []).map((result) => {
  const campaign = campaigns.find((candidate) => (
    candidate.campaignID === result.campaignID && candidate.projectID === result.projectID
  ));
  const country = countries.find((candidate) => (
    String(candidate.countryID) === String(result.countryID)
  ));
  const countryName = (campaign && campaign.countryName) || (country && country.name) || `Country ${result.countryID}`;
  return {
    campaignID: result.campaignID,
    projectID: result.projectID,
    code: (campaign && campaign.countryCode) || (country && country.code) || '',
    country: countryName,
    countryID: result.countryID,
    sheetGroups: (result.sheetGroups || []).map((group) => ({
      groupID: group.groupID,
      channel: group.channel,
      controlGroupPercentage: (group.experiment && group.experiment.controlGroupPercentage) || 0,
      variants: (group.variants || []).map((variant) => ({
        ...variant,
        criteria: variant.criteria || {},
      })),
    })),
    datalakeGroups: (result.datalakeGroups || []).map((group) => ({
      country: countryName,
      groupID: group.groupID,
      paxCount: Number(group.paxCount || 0),
    })),
  };
});
